/**
 * Поле за число, което се пише на ръка.
 *
 * Обикновеното `type="number"` носи стрелки нагоре и надолу, а с тях и
 * колелцето на мишката: един случаен щрак върху количество 1 при стъпка
 * 0.001 го прави 1.001, а върху цена 4.54 — 4.55. Промяната е тиха,
 * става с движение, което човек не е искал, и после стои в записан
 * документ. Затова тук няма стрелки.
 *
 * Полето приема само цифри. Десетичната запетая се превръща в точка —
 * на българската подредба тя е под ръка, а стойността се пази като низ
 * и се смята оттам.
 */

/** Оставя само това, което може да е число. */
function clean(raw, integer) {
  let s = String(raw ?? '').replace(/,/g, '.');
  if (integer) return s.replace(/[^\d]/g, '');

  s = s.replace(/[^\d.]/g, '');
  // Втора точка не влиза — иначе „1.2.3" стига до сметките като NaN.
  const i = s.indexOf('.');
  if (i >= 0) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, '');
  return s;
}

export default function NumBox({ value, onChange, integer = false, ...rest }) {
  return (
    <input
      type="text"
      inputMode={integer ? 'numeric' : 'decimal'}
      autoComplete="off"
      value={value ?? ''}
      onChange={(e) => onChange(clean(e.target.value, integer))}
      {...rest}
    />
  );
}
